import { Http } from '@gamiphy/http';
import { Site } from '@gamiphy/bl/site';

export class SiteApi {
  public static async createSite(site: Omit<Site, 'id'>): Promise<Site> {
    const response = await Http.post<CreateSiteResponse>({
      url: '/v1/sites',
      payload: site,
    });
    return response.data.site;
  }

  public static async updateSite(siteId: string, data: Partial<Site>): Promise<Site> {
    const response = await Http.post<UpdateSiteResponse>({
      url: `/v1/sites/${siteId}`,
      payload: data,
    });
    return response.data.site;
  }

  public static async listSites(filters?: Record<string, string>): Promise<Site[]> {
    const response = await Http.get<ListSitesResponse>({
      url: '/v1/sites',
      query: filters,
    });
    return response.data.sites;
  }

  public static async deleteSite(siteId: string): Promise<void> {
    await Http.delete<void>({
      url: `/v1/sites/${siteId}`,
    });
  }
}

export type CreateSiteResponse = {
  site: Site
}

export type UpdateSiteResponse = {
  site: Site
}

export type ListSitesResponse = {
  sites: Site[]
}
